import { render, staticRenderFns } from "./DataTableCell.vue?vue&type=template&id=2760b1a0&"
import script from "./DataTableCell.vue?vue&type=script&lang=js&"
export * from "./DataTableCell.vue?vue&type=script&lang=js&"
import style0 from "./DataTableCell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports